<template>
  <div class="row poppins h-100">
    <div class="col-12 h-100">
      <div class="table-wrapper h-100 d-flex flex-column">
        <div class="filter-block justify-content-end">
          <!-- <SearchInput :searchChange="searchChange" /> -->
          <div class="d-flex">
            <b-dropdown
              v-if="!isGeneratingPdf"
              variant="primary"
              right
              :text="'Generate PDF' | i18n"
              size="lg"
              toggle-class="pl-4 pr-4"
              class="ml-3"
              :disabled="!selectedList.length"
            >
              <b-dropdown-item @click="() => generatePDF({ type: STICKER_TYPES.TEXT })">
                {{ 'Generate text PDF' | i18n }}
              </b-dropdown-item>
              <b-dropdown-item v-b-modal="`generate-sticker-pdf`">
                {{ 'Generate barcode PDF' | i18n }}
              </b-dropdown-item>
            </b-dropdown>
            <b-button
              v-else
              variant="primary"
              size="lg"
              class="ml-3 pl-3 pr-4 d-flex align-items-center"
              disabled
            >
              <b-spinner v-if="isGeneratingPdf" small class="mr-3" />
              {{ $translate('Generating') }}
            </b-button>
            <b-button variant="primary" size="lg" class="ml-3 pl-3 pr-4 d-flex align-items-center" @click="importExcelFile">
              <BIconPlus class="mr-2" />
              {{ 'New sticker' | i18n }}
            </b-button>
            <SelectCompanyModal
              :companies="companies"
              :onGeneratePdf="(company) => generatePDF({ type: STICKER_TYPES.BARCODE, company })"
            />
          </div>
        </div>
        <Table
          :update="getPage"
          :columns="columns"
          :rows="rows"
          :filter="filter"
          :updateFilter="updateFilter"
          :loadingInstance="loadingInstance"
          :setLoadingInstance="setLoadingInstance"
          :selectedList="selectedList"
          :setSelectedList="setSelectedList"
          class="overflow-auto pr-1"
          tableName="stickersTable"
        />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { BIconPlus, BIconSearch } from 'bootstrap-vue';
import { ListMixin, DeleteRowMixin, NotificationMixin, AuthMixin } from '../../../../mixins';
import api from '../../../api';
import PageHeader from '../../common/page-header';
import Table from '../../common/table';
import SearchInput from '../../common/search-input';
import { STICKER_TYPES } from '../../../../../../../constants';
import SelectCompanyModal from './select-company-modal';

let inputInterval = null;

export default {
  title: 'Stickers',
  components: { PageHeader, BIconPlus, BIconSearch, Table, SearchInput, SelectCompanyModal },
  mixins: [ListMixin, DeleteRowMixin, NotificationMixin, AuthMixin],
  data() {
    const columnsValue = [
      { field: 'containerSize', title: this.$translate('Container size'), },
      { field: 'fraction', title: this.$translate('Fraction'), },
      { field: 'inventoryNumber', title: this.$translate('Inventory number'), },
      { field: 'rhythm', title: this.$translate('Rhythm'), },
      { field: 'street', title: this.$translate('Street'), },
      { field: 'houseNumber', title: this.$translate('House number'), },
      { field: 'district', title: this.$translate('District'), },
      { field: 'location', title: this.$translate('Location'), },
      { field: 'city', title: this.$translate('City'), },
      { field: 'postalCode', title: this.$translate('Postal code'), },
      { field: 'municipality', title: this.$translate('Municipality'), },
      { field: 'community', title: this.$translate('Community'), },
      { field: 'crest', title: this.$translate('Crest'), },
      { field: 'coatOfArms', title: this.$translate('Coat of arms'), },
      { field: 'additionalIdentifiers', title: this.$translate('Additional identifiers'), },
    ];

    const additionalColumnsProperty = {
      sortBy: '',
      align: 'left',
    };

    const generateCustomFilter = (columnKey) => {
      return {
        defaultVisible: false,
        render: ({ showFn, closeFn }, h) => {
          return (
            <div class="custom-name-filter">
              <input
                value={this.filter.searchQuery[columnKey]}
                on-input={(e) => (this.filter.searchQuery[columnKey] = e.target.value)}
                placeholder={this.$translate('Search value')}
              />
              <div class="custom-name-filter-operation">
                <span class="name-filter-cancel" on-click={() => closeFn()}>
                  {this.$translate('Cancel')}
                </span>
                <span class="name-filter-confirm" on-click={() => this.searchConfirm(closeFn)}>
                  {this.$translate('Search')}
                </span>
              </div>
            </div>
          );
        },
        filterIcon: () => {
          return <ve-icon name="search" />;
        },
      };
    };

    const searchQuery = {};
    columnsValue.forEach((column) => {
      searchQuery[column.field] = '';
    });

    return {
      STICKER_TYPES,
      localBasePath: axios.defaults.baseURL,
      selectedList: [],
      loadingInstance: null,
      isGeneratingPdf: false,
      accessToken: '',
      companies: [],
      selectedCompany: null,
      filter: {
        page: 1,
        limit: 10,
        totalCount: 0,
        sortBy: '',
        sortOrder: '',
        searchQuery,
      },
      columns: [
        {
          field: 'check',
          key: 'check',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center',
        },
        ...columnsValue.map(({ field, title }) => ({
          field,
          title,
          key: field,
          filterCustom: generateCustomFilter(field),
          ...additionalColumnsProperty,
        })),
      ],
      rows: [],
    };
  },
  async created() {
    const auth = this.authStorageService.getAuth();
    this.accessToken = auth.access_token_link;
    const companies = await api.commonCompany.get();
    this.companies = companies.map((c) => {
      return { value: c.id, text: c.name };
    });
  },
  methods: {
    async importExcelFile() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = '.xlsx';
      input.onchange = async (e) => {
        try {
          const file = e.target.files[0];
          const formData = new FormData();
          formData.append('file', file);
          await api.sticker.importFile(formData);
          await this.getPage();
          this.showNotification({ type: 'success', message: this.$translate('Cases was successfully imported!') });
        } catch (error) {
          this.showNotification({ type: 'error', message: this.$translate('Cases was not imported!') });
        }
      };

      input.click();
    },
    async generatePDF({ type, company }) {
      try {
        this.isGeneratingPdf = true;
        const { data } = await api.sticker.generatePdf({ idList: this.selectedList.map(({ id }) => id), type, company });
        if (data.pdfName) {
          const url = `${this.localBasePath}/api/v1/reports/stickers-download-pdf/${data.pdfName}?authorization=${this.accessToken}`;
          await axios(`${url}&delete=false`);
          window.open(`${url}&delete=true`, '_blank');
        }
        this.showNotification({ type: 'success', message: this.$translate('PDF was successfully downloaded!') });
      } catch (error) {
        this.showNotification({ type: 'error', message: this.$translate('Generate pdf error') });
      } finally {
        this.isGeneratingPdf = false;
      }
    },
    updateFilter(f) {
      this.filter = {
        ...this.filter,
        ...f,
      };
    },
    setSelectedList(list) {
      this.selectedList = list;
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    searchChange(e) {
      // const v = e.target.value;
      // this.filter.searchQuery = v;
      if (inputInterval) {
        clearTimeout(inputInterval);
      }
      inputInterval = setTimeout(() => {
        this.getPage();
      }, 500);
    },
    searchConfirm(closeFn) {
      this.searchChange();
      closeFn();
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    async deleteList(id) {
      await this.deleteSelectedRows(null, async () => {
        try {
          this.startLoading();
          await this.listService.remove(id);
          this.getPage();
        } catch (err) {
          this.stopLoading();
          this.showNotification({ type: 'error', message: err.message });
        }
      });
    },
    async getPage() {
      try {
        this.startLoading();
        const { page, limit, sortBy, sortOrder, status, searchQuery } = this.filter;
        const ctx = {
          page,
          limit,
          sortBy,
          sortOrder,
          searchQuery,
        };
        if (status) {
          ctx.status = status;
        }
        const response = await api.sticker.get(ctx);
        this.filter.totalCount = response.totalCount;
        this.rows = response.data;
        this.stopLoading();
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ve-table-body {
  ::v-deep th {
    color: rgb(112, 112, 112) !important;
    background-color: rgb(239, 239, 239) !important;
    border: none !important;
    min-height: 50px;
  }
  ::v-deep td {
    color: rgb(112, 112, 112) !important;
    cursor: pointer;
  }
}

::v-deep .ve-table-cell-selection {
  border: none !important;
}

::v-deep .ve-table-sort {
  top: -4.5px;
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: auto;
}

.statuses-block {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.date-range-block {
  min-width: 350px;
  text-align: center;
  margin-left: 30px;
  display: flex;
  align-items: center;
}

::v-deep .ve-select-selected-span {
  font-weight: 400;
}

.pagination-block {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.action-block {
  display: flex;
}

::v-deep .copy-button {
  background: rgb(237, 248, 254);
  border: 2px solid rgb(175, 216, 255);
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  color: rgb(49, 141, 255);
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-right: 20px;
  cursor: pointer;
}

::v-deep .delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border-color: #db474f;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 2px 13px;
  margin: 0px 5px;
  cursor: pointer;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}

::v-deep .dropdown-toggle::after {
  margin-left: 10px;
}
</style>
